<template>
    <div
        class="homepageGraphic__contentElement contentElement"
        :class="`-${currentKey}`"
    >
        <div class="contentElement__flipper" v-if="contentLoaded">
            <FrontPanel 
                :title="title"
                :introduction="introduction"
            />
            <BackPanel
                :title="title"
                :features="features"
                :ctas="ctas"
            />
            <Images
                :images="images"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FrontPanel from './FrontPanel'
import BackPanel from './BackPanel'
import Images from './Images'

export default {

    data() {
        return {
            contentLoaded: false,
        }
    },

    components: {
        FrontPanel,
        BackPanel,
        Images,
    },

    computed: {
        ...mapState(['currentKey']),
        ...mapGetters(['currentData']),

        title () {
            return this.currentData.title
        },

        introduction () {
            return this.currentData.introduction
        },

        features () {
            return this.currentData.features
        },

        ctas () {
            return this.currentData.ctas
        },

        images () {
            return this.currentData.images
        },
    },
    async mounted() {
        await this.$store.dispatch('getImpact')
        this.contentLoaded = true;
    }

}
</script>
